import styled from '@emotion/styled';
import { useRef } from 'react';
import { mergeProps, useFocusRing, useTableRow } from 'react-aria';

import { su } from '../../../theme/functions/su';
import { theme } from '../../../theme/theme';

export function SettingsTableRow(props) {
  const ref = useRef();
  // const isSelected = props.state.selectionManager.isSelected(props.item.key);

  const tableRow = useTableRow(
    {
      node: props.item,
    },
    props.state,
    ref,
  );
  const focusRing = useFocusRing();

  return (
    <S.TableRow {...mergeProps(tableRow.rowProps, focusRing.focusProps)} ref={ref}>
      {props.children}
    </S.TableRow>
  );
}

SettingsTableRow.contextMenuButtonClass = 'settingsTableRowContextMenuButton';

function S() {}
SettingsTableRow.S = S;

S.TableRow = styled.tr`
  position: relative;
  outline: none;
  box-shadow: none;

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  td:not(:first-child) {
    text-align: end;
  }

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  td:first-child {
    padding-inline-start: ${su(2)};
  }

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  td:last-child {
    padding-inline-end: ${su(2)};
  }

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  &:first-child {
    /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
    td:first-child {
      border-start-start-radius: ${theme.borderRadius.default};
    }

    /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
    td:last-child {
      border-start-end-radius: ${theme.borderRadius.default};
    }
  }

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  &:last-child {
    /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
    td:last-child {
      border-end-end-radius: ${theme.borderRadius.default};
    }

    /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
    td:first-child {
      border-end-start-radius: ${theme.borderRadius.default};
    }
  }

  /* @emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */
  &:not(:last-child)::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background-color: ${theme.color.line};
  }

  .${SettingsTableRow.contextMenuButtonClass} {
    opacity: 1;
  }
`;
